export default __webpack_public_path__ + "static/media/ssc-qyzsk.df73c77d.png";